<template>
  <router-view />
</template>

<script>
import { READ } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Assets',
      breadcrumb: {
        name: 'Assets',
        route: { name: 'configuration-assets' }
      },
      sidebar: [
        {
          hidden: this.$user.cannot(READ, this.$sdk.asset_type),
          name: 'Types',
          icon: ['fal', 'phone-laptop'],
          route: { name: 'configuration-assets-types' }
        },
        {
          hidden: this.$user.cannot(READ, 'assetmanufacturer'),
          name: 'Manufacturers',
          icon: ['fal', 'industry-alt'],
          route: { name: 'configuration-assets-manufacturers' }
        },
        {
          hidden: this.$user.cannot(READ, 'assetmanufacturer_model'),
          name: 'Models',
          icon: ['fal', 'print'],
          route: { name: 'configuration-assets-models' }
        }
      ]
    }
  }
}
</script>
